import {
    TYPE_BROADCAST_SCHEDULE,
    TYPE_SCHEDULE,
} from "../../../../constants/page";
import { page_update_sections } from "../../../../reducers/Page/reducer";
import { DEFAULT_TIMEZONE } from "../../../../utils/dateTime/constants";
import {
    getTimezoneLocale,
    getUserTimeZone,
} from "../../../../utils/dateTime/library";
import { isBrowser } from "../../../../utils/environmentDetection/library";
import { PAGE_DESCRIPTION_TEMPLATE } from "./constants";

export const mainSchedulePageReducer = (page) => {
    const type = page?.sections?.[0]?.main?.content?.[0]?.type;
    if (type === TYPE_BROADCAST_SCHEDULE || type === TYPE_SCHEDULE) {
        const timezone = isBrowser() ? getUserTimeZone() : DEFAULT_TIMEZONE;
        const timezoneLocale = getTimezoneLocale(timezone);
        const timezoneText = PAGE_DESCRIPTION_TEMPLATE(timezoneLocale);

        if (page?.timezoneText !== timezoneText) {
            return {
                ...page,
                timezoneText,
            };
        }
    }
    return page;
};

export const updatePageDescription = (dispatch, page) => {
    const nextPage = mainSchedulePageReducer(page);
    if (page !== nextPage) {
        dispatch(page_update_sections(nextPage));
    }
};
